<script lang="ts">
  import type { Writable } from "svelte/store";
  import type { Field } from "svelte-forms2/types";

  type EventHandler = (e: Event) => void;
  type FormField = Writable<Field<string>>;

  export let name: string;
  export let label: string;
  export let placeholder = "";
  export let field: FormField;
  export let onblur: EventHandler;
  export let stack = true;

  function cleanNumber(field) {
    return function (e) {
      let cleanedNumber = "";

      if (e.target.value) {
        cleanedNumber = e.target.value.replace(/\D/g, "");
      }

      field.set(cleanedNumber);
    };
  }

</script>

<label class="fizz-half-width fizz-inline-block" class:fizz-stack-16={stack}>
  <p class="fizz-stack-8 fizz-label"><strong>{label}</strong></p>
  <input
    type="tel"
    {name}
    {placeholder}
    data-testId={name}
    class="fizz-input-text fizz-full-width"
    class:fizz-input-error={!$field.valid}
    bind:value={$field.value}
    on:blur={onblur}
    on:keyup={cleanNumber(field)}
  />
  <slot />
</label>
